import { Button, createTheme, Paper } from "@mantine/core";
import "./theme.scss";

// The one Mantine theme for the admin. Mounted once, at the root provider in src/index.jsx;
// no page or component re-declares it. Values mirror assets/styles/_tokens.scss so Mantine
// components and the existing SCSS pages read as one system.

// Brand purple: index 8 is --brand-primary (#5b21b6), index 7 is --brand-accent (#6d28d9),
// index 1 is --brand-purple-light (#ede9fe).
const blikst = ["#f5f3ff", "#ede9fe", "#ddd6fe", "#c4b5fd", "#a78bfa", "#8b5cf6", "#7c3aed", "#6d28d9", "#5b21b6", "#4c1d95"];

// --gray-50 … --gray-900 from the tokens, so Mantine's default neutrals match the pages.
const gray = ["#f9fafb", "#f3f4f6", "#e5e7eb", "#d1d5db", "#9ca3af", "#6b7280", "#4b5563", "#374151", "#1f2937", "#111827"];

const theme = createTheme({
  primaryColor: "blikst",
  primaryShade: 8,
  fontFamily: "Poppins, sans-serif",
  headings: { fontFamily: "Poppins, sans-serif", fontWeight: "700" },
  defaultRadius: "md",
  cursorType: "pointer",
  colors: { blikst, gray },
  // --text-sm … --text-xl
  fontSizes: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "16px" },
  // --radius-sm … --radius-xl
  radius: { xs: "2px", sm: "4px", md: "6px", lg: "8px", xl: "10px" },
  components: {
    Button: Button.extend({
      defaultProps: { size: "sm" },
      styles: { root: { fontWeight: 500 } },
    }),
    Paper: Paper.extend({
      defaultProps: { withBorder: true, radius: "lg" },
    }),
  },
});

export default theme;
